import { useCallback, useEffect, useState } from 'react';
import { CurrentStatusResponse } from '../models/api';
import { getCurrentStatus } from '../services/checkout.service';

export interface UseCurrentStatusResult {
  data?: CurrentStatusResponse;
  loading: boolean;
  error?: string;
}
export function useCurrentStatus(): UseCurrentStatusResult & {
  refetch: () => Promise<void>;
} {
  const [data, setData] = useState<CurrentStatusResponse>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();

  const fetchStatus = useCallback(async () => {
    try {
      setLoading(true);
      setError(undefined);

      const res = await getCurrentStatus();
      if (res.success && res.data) {
        setData(res.data);
      } else {
        setError('Failed to load status');
      }
    } catch (err) {
      console.error(err);
      setError('An error occurred while fetching status');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return { data, loading, error, refetch: fetchStatus };
}
